module.exports = __webpack_public_path__ + "static/media/Car.eae5a2d7.svg";